import { render, staticRenderFns } from "./ExternalUserRegister.vue?vue&type=template&id=3f870868&scoped=true&"
import script from "./ExternalUserRegister.vue?vue&type=script&lang=ts&"
export * from "./ExternalUserRegister.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalUserRegister.vue?vue&type=style&index=0&id=3f870868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f870868",
  null
  
)

export default component.exports